module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KzMQP2/tc-custom/9781439674642.jpg?1694070817877",
      "alt": "This image is the cover for the book Red Sox in the Hall of Fame, Images of Baseball"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Red Sox in the Hall of Fame, Images of Baseball\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For nearly 50 consecutive years, three players toiled their trade in the shadow of Fenway Park's revered left field Green Monster. Ted Williams, Carl Yastrzemski, and Jim Rice became legends in Boston sports history and eventually baseball immortals with their inductions into the Baseball Hall of Fame. These three lead a remarkable cast of baseball giants who have been inducted into the Baseball Hall of Fame and also spent time as members of the Boston Red Sox organization. A few distinguished players include Cy Young, Carlton Fisk, Babe Ruth, Wade Boggs, Bobby Doerr, Tris Speaker, and Pedro Martinez. Collectively, they are all part of one of the greatest sports stories ever told, the Red Sox in the Hall of Fame.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Hickey, Kerry Keene\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lifelong Red Sox fans, baseball historians David Hickey and Kerry Keene also coauthored Images of America: Fenway Park.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0